import React, { useState } from 'react'
import { Row, Col, FormGroup, Label, Button, Input, Table } from 'reactstrap';


const AddSubstack = (props) => {
    const { substackDetails } = props;
    const [substackName, setSubstackName] = useState("");
    const [substackTitle, setSubstackTitle] = useState("");
    const [substackDescription,setSubstackDescription] = useState("");
    const [countDetails, setCountDetails] = useState([]);
    const [countId, setCountId] = useState(0);
    const [isCountEdit, setIsCountEdit] = useState(false);
    const [countEditIndex, setCountEditIndex] = useState(0);
    const [isPositionModal, setIsPositionModal] = useState(false);
    const [positionIndex, setPositionIndex] = useState(0);

    React.useEffect(() => {
        setCountDetails([...substackDetails])
    }, [substackDetails]);

    const handleSubstackName = event => {
        setSubstackName(event.target.value);
    };

    const handleSubstackTitle = event => {
        setSubstackTitle(event.target.value);
    };

    const handleSubstackDescription = event => {
        setSubstackDescription(event.target.value)
    }

    const handleMediaCancel = () => {
        setSubstackName("");
        setSubstackTitle("");
        setSubstackDescription("");
    };

    const handleMediaSave = () => {
        let data;
        if (isCountEdit) {
            const item = countDetails[countEditIndex];
            item.substackName = substackName;
            item.substackTitle = substackTitle;
            item.substackDescription = substackDescription;
            setCountDetails([...countDetails]);
            props.handleSubstacks(countDetails);
        } else {
            data = [
                {
                    substackName: substackName,
                    substackTitle: substackTitle,
                    substackDescription: substackDescription,
                }
            ];
            setCountDetails([...data, ...countDetails]);
            let array = [...data, ...countDetails]
            props.handleSubstacks(array);
        }
        handleMediaCancel();
        setIsCountEdit(false);
    };


    const handleMediaDelete = index => {
        countDetails.splice(index, 1);
        setCountDetails([...countDetails]);
        props.handleSubstacks(countDetails);
    };

    const handleMediaEdit = index => {
        const item = countDetails[index];
        setSubstackName(item.substackName);
        setSubstackTitle(item.substackTitle);
        setSubstackDescription(item.substackDescription)
        setIsCountEdit(true);
        setCountEditIndex(parseInt(index));
    };



    return (
        <Row className="mx-0">
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <h6 className="h6-small external-title align-center title-bright-grey bg-zircon-grey p-2">
                    Add Subtasks Details :
                </h6>
            </Col>
            <Col
                xs={12}
                sm={12}
                md={12}
                lg={8}
                xl={8}
                className="m-auto mt-4"
            >
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <FormGroup
                            row
                            className="mx-0 align-items-center"
                        >
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Label className="common-label text-left">
                                Subtasks Heading :
                                </Label>
                                <Input
                                    type="text"
                                    placeholder="Substack Heading"
                                    id="substackName"
                                    name="substackName"
                                    className="form-control common-form-control"
                                    value={substackName}
                                    onChange={event => handleSubstackName(event)}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup
                            row
                            className="mx-0 align-items-center"
                        >
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Label className="common-label text-left">
                                Subtasks Title :
                                </Label>
                                <Input
                                    type="text"
                                    placeholder="Subtasks Title"
                                    id="substackTitle"
                                    name="substackTitle"
                                    className="form-control common-form-control"
                                    value={substackTitle}
                                    onChange={event =>
                                        handleSubstackTitle(event)
                                    }
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup
                            row
                            className="mx-0 align-items-center"
                        >
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Label className="common-label text-left">
                                Subtasks Description :
                                </Label>
                                <Input
                                    type="textarea"
                                    placeholder="Subtasks Description"
                                    id="substackDescription"
                                    name="substackDescription"
                                    className="form-control common-form-control"
                                    value={substackDescription}
                                    onChange={(event) => handleSubstackDescription(event)}
                                    dateFormat="MM/DD/YYYY"
                                />
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col
                        xs={10}
                        sm={10}
                        md={8}
                        lg={6}
                        xl={6}
                        className="ml-auto mb-3"
                    >
                        <FormGroup
                            row
                            className="mx-0 align-items-center"
                        >
                            <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                <Button
                                    className="btn btn-block custom-danger-btn custom-btn--small br-4px"
                                    onClick={handleMediaCancel}
                                >
                                    Cancel
                                </Button>
                            </Col>
                            <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                <Button
                                    className="btn btn-block custom-theme-btn custom-btn--small br-4px"
                                    onClick={handleMediaSave}
                                    disabled={substackName && substackTitle && substackDescription ? false : true}
                                >
                                    Save
                                </Button>
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <FormGroup
                            row
                            className="mx-0 align-items-center"
                        >
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Table bordered responsive>
                                    <thead className="custom-table-thead">
                                        <tr>
                                            <th>Media Name</th>
                                            <th>Media Link</th>
                                            <th>Date</th>
                                            <th>Action</th>


                                        </tr>
                                    </thead>
                                    <tbody className="custom-table-tbody">
                                        {substackDetails.map((it, index) => (
                                            <tr key={index}>
                                                <td>{it.substackName}</td>
                                                <td>{it.substackTitle}</td>
                                                <td>{it.substackDescription}</td>
                                                <td>
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <div
                                                            onClick={() =>
                                                                handleMediaDelete(index)
                                                            }
                                                        >
                                                            <Button className="btn btn-small custom-danger-btn custom-btn-small fs-10px">
                                                                Delete
                                                            </Button>
                                                        </div>
                                                        <div
                                                            className="ml-12px"
                                                            onClick={() =>
                                                                handleMediaEdit(index)
                                                            }
                                                        >
                                                            <Button className="btn btn-small custom-edit-btn custom-btn-small fs-10px">
                                                                Edit
                                                            </Button>
                                                        </div>
                                                        {/* <div
                                                            className="ml-12px"
                                                            onClick={() =>
                                                                handlePosition(index)
                                                            }
                                                        >
                                                            <Button className="btn btn-small custom-edit-btn custom-btn-small fs-10px">
                                                                Position
                                                            </Button>
                                                        </div> */}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        </FormGroup>
                    </Col>
                </Row>
            </Col>
         </Row>
    )
}


export default AddSubstack;